import React from 'react';
import { api } from '../../api/apiService';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from "react-toastify";

// Yup schema for validation
const schema = yup.object().shape({
    date: yup
        .string()
        .required("Date is required"),
    time: yup
        .string()
        .required("Time is required"),
    check_type: yup
        .string()
        .required("Type is required"),
});

const AttendanceModal = ({ show, onClose, currentEmployee }) => {
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });

    const formatTime = (time24h) => {
        if (!time24h) return '';
        const [hours, minutes] = time24h.split(':');
        const date = new Date(2000, 0, 1, hours, minutes);

        // Format time as hh:mm AM/PM with padded zeros
        let hours12 = date.getHours() % 12;
        hours12 = hours12 ? hours12 : 12; // Convert '0' hours to '12'
        const paddedHours = hours12.toString().padStart(2, '0'); // Ensure 2 digits
        const paddedMinutes = date.getMinutes().toString().padStart(2, '0');
        const ampm = date.getHours() >= 12 ? 'PM' : 'AM';

        return `${paddedHours}:${paddedMinutes} ${ampm}`;
    };

    const onSubmit = async (data) => {
        try {
            const payload = {
                ...data,
                employee_id: currentEmployee?.employee_id,
                time: formatTime(data.time),
            };
            const response = await api.post("/add-attendance", payload);
            const result = response.data;
            toast.success(result.message);
            onClose();
        }
        catch (error) {
            if (error?.data && error?.data.errors) {
                error?.data.errors.forEach(err => {
                    toast.error(err);
                });
            } else {
                toast.error("An error occurred. Please try again");
            }
        }
    };


    if (!show) return null;

    return (
        <div className="modal fade show d-block">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Add Attendance</h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={onClose}
                        ></button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <label className="form-label fw-bold">Select Date</label>
                                    <input
                                        type="date"
                                        name="date"
                                        className={`form-control ${errors.date ? "is-invalid" : ""}`}
                                        {...register("date")}
                                    />
                                    <div className="invalid-feedback">{errors.date?.message}</div>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label fw-bold">Select Time</label>
                                    <input
                                        type="time"
                                        name="time"
                                        className={`form-control ${errors.time ? "is-invalid" : ""}`}
                                        {...register("time")}
                                    />
                                    <div className="invalid-feedback">{errors.time?.message}</div>
                                </div>
                            </div>

                            <div className="mb-3">
                                <label className="form-label fw-bold">Type</label>
                                <div className="d-flex gap-4">
                                    <div className="form-check">
                                        <input
                                            type="radio"
                                            id="Check In"
                                            value="Check In"
                                            className={`form-check-input ${errors.check_type ? "is-invalid" : ""
                                                }`}
                                            {...register("check_type")}
                                        />
                                        <label className="form-check-label" htmlFor="Check In">
                                            Check In
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input
                                            type="radio"
                                            id="Check Out"
                                            value="Check Out"
                                            className={`form-check-input ${errors.check_type ? "is-invalid" : ""
                                                }`}
                                            {...register("check_type")}
                                        />
                                        <label className="form-check-label" htmlFor="Check Out">
                                            Check Out
                                        </label>
                                    </div>
                                </div>
                                {errors.check_type && (
                                    <div className="text-danger mt-1">{errors.check_type.message}</div>
                                )}
                            </div>

                            <div className="mb-3">
                                <label className="form-label fw-bold">Remarks</label>
                                <textarea
                                    name="remarks"
                                    className="form-control"
                                    rows="3"
                                    {...register("remarks")}
                                ></textarea>
                            </div>

                            <div className="text-end mt-4">
                                <button type="submit" className="btn btn-primary">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AttendanceModal;
